module.exports = __webpack_public_path__ + "img/ruijie.d0f00d79.svg";